// custom-breadcrumbs.js
import React from "react"
import { Breadcrumbs, Link, Typography } from "@material-ui/core"

const CustomBreadcrumbs = ({ links }) => {
  return (
    <Breadcrumbs aria-label="breadcrumb">
      {links.map((link, index) =>
        link.href ? (
          <Link key={index} color="inherit" href={link.href}>
            {link.label}
          </Link>
        ) : (
          <Typography key={index} color="textPrimary">
            {link.label}
          </Typography>
        ),
      )}
    </Breadcrumbs>
  )
}

export default CustomBreadcrumbs
